import { render, staticRenderFns } from "./quotation-info.vue?vue&type=template&id=c99b047c"
import script from "./quotation-info.vue?vue&type=script&lang=js"
export * from "./quotation-info.vue?vue&type=script&lang=js"
import style0 from "./quotation-info.vue?vue&type=style&index=0&id=c99b047c&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c99b047c')) {
      api.createRecord('c99b047c', component.options)
    } else {
      api.reload('c99b047c', component.options)
    }
    module.hot.accept("./quotation-info.vue?vue&type=template&id=c99b047c", function () {
      api.rerender('c99b047c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/quotation-info.vue"
export default component.exports